import baseUrl from './baseUrl';
import { decrypt } from '../helpers/cryptography';

const URL_GET_CHAMADO_BY_ID = `${baseUrl}/chamado`;

const decryptOrOriginal = value => {
  if (!value) {
    return '';
  }

  try {
    return decrypt(value);
  } catch (error) {
    return value;
  }
};

const getChamadoById = async id => {
  try {
    const data = await fetch(`${URL_GET_CHAMADO_BY_ID}/${id}`, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!data.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }

    const response = await data.json();

    const cipaInscricao = {
      ...response?.cipaInscricao,
      nome: decryptOrOriginal(response?.cipaInscricao?.nome),
      email: decryptOrOriginal(response?.cipaInscricao?.email),
      cargo: decryptOrOriginal(response?.cipaInscricao?.cargo),
      matricula: decryptOrOriginal(response?.cipaInscricao?.matricula)
    };

    const erp = {
      ...response?.erp,
      erpNome: response?.erp?.erpNome ? decrypt(response?.erp?.erpNome) : '',
      erpEmail: response?.erp?.erpEmail ? decrypt(response?.erp?.erpEmail) : ''
    };

    const suporteTi = {
      ...response?.suporteTi,
      telContatoTi: response?.suporteTi?.telContatoTi ? decrypt(response?.suporteTi?.telContatoTi) : ''
    };

    const responseEncrypted = {
      email: response?.email ? decrypt(response?.email) : '',
      nome: response?.nome ? decrypt(response?.nome) : '',
      telefone: response?.telefone ? decrypt(response?.telefone) : null,
      categoria: response?.categoria,
      subcategoria: response?.subcategoria,
      unidade: response?.unidade,
      relato: response?.relato,
      sla: response?.sla,
      obs: response?.obs,
      userResp: response?.userResp,
      status: response?.status,
      responder: response?.responder ? decrypt(response?.responder) : null,
      materiaisEscritorio: response?.materiaisEscritorio ?? [],
      materiaisLimpeza: response?.materiaisLimpeza ?? [],
      materiaisExpediente: response?.materiaisExpediente ?? [],
      solicitacaoVeiculo: response?.solicitacaoVeiculo,
      solicitacaoMotoboy: response?.solicitacaoMotoboy,
      solicitacaoFerias: response?.solicitacaoFerias,
      alteracaoFerias: response?.alteracaoFerias,
      criacaoEmail: response?.criacaoEmail,
      loginSistemas: response?.loginSistemas,
      equipamentoEngenhariaClinica: response?.equipamentoEngenhariaClinica,
      briefing: response?.briefing,
      trienio: response?.trienio,
      cipaInscricao,
      erp,
      suporteTi,
      numeroChamado: response?.numeroChamado,
      createdAt: response?.createdAt,
      finalAt: response?.finalAt,
      pontoEletronico: response?.pontoEletronico,
      requerimentoInsumos: response?.requerimentoInsumos,
      requerimentoMedicamentos: response?.requerimentoMedicamentos,
    };
    
    return responseEncrypted;
  } catch (error) {
    console.log(error);
  }
};

export default getChamadoById;
